/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF API v1.0
 * TAF API with OpenAPI, Swashbuckle, and API versioning.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  Assignment,
  ClubMember,
  CreateMemberRequest,
  Employment,
  EmploymentV2Model,
  GetApiV1MemberClubMembersParams,
  MemberBooking,
  MemberResponseModel,
  OrganizationUnitResponseModel,
  PersonResponseModel,
  ProblemDetails,
  UpdateMemberEmploymentRequest,
  UpdateMemberNewEmploymentRequest,
  UpdateMemberRequest
} from '../../models'
import { customInstance } from '../../../../utils/mutator/custom-instance';
import type { ErrorType, BodyType } from '../../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getApiV1MemberSessionId = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberResponseModel>(
      {url: `/proxy/api/v1/member/${sessionId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}`] as const;
    }

    
export const getGetApiV1MemberSessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionId>>> = ({ signal }) => getApiV1MemberSessionId(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionId>>>
export type GetApiV1MemberSessionIdQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionId<TData = Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionId>>> = ({ signal }) => getApiV1MemberSessionId(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionId>>>
export type GetApiV1MemberSessionIdSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberV2SessionId = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PersonResponseModel>(
      {url: `/proxy/api/v1/member/v2/${sessionId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberV2SessionIdQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/v2/${sessionId}`] as const;
    }

    
export const getGetApiV1MemberV2SessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>> = ({ signal }) => getApiV1MemberV2SessionId(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>>
export type GetApiV1MemberV2SessionIdQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionId<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberV2SessionIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>> = ({ signal }) => getApiV1MemberV2SessionId(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>>
export type GetApiV1MemberV2SessionIdSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionIdSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiV1Member = (
    createMemberRequest: BodyType<CreateMemberRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/proxy/api/v1/member`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMemberRequest, signal
    },
      options);
    }
  


export const getPostApiV1MemberMutationOptions = <TData = Awaited<ReturnType<typeof postApiV1Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<CreateMemberRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV1Member'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Member>>, {data: BodyType<CreateMemberRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Member(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{data: BodyType<CreateMemberRequest>}, TContext>}

    export type PostApiV1MemberMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Member>>>
    export type PostApiV1MemberMutationBody = BodyType<CreateMemberRequest>
    export type PostApiV1MemberMutationError = ErrorType<unknown>

    export const usePostApiV1Member = <TData = Awaited<ReturnType<typeof postApiV1Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<CreateMemberRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {data: BodyType<CreateMemberRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiV1MemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const putApiV1Member = (
    updateMemberRequest: BodyType<UpdateMemberRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/proxy/api/v1/member`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberRequest
    },
      options);
    }
  


export const getPutApiV1MemberMutationOptions = <TData = Awaited<ReturnType<typeof putApiV1Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['putApiV1Member'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1Member>>, {data: BodyType<UpdateMemberRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putApiV1Member(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberRequest>}, TContext>}

    export type PutApiV1MemberMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1Member>>>
    export type PutApiV1MemberMutationBody = BodyType<UpdateMemberRequest>
    export type PutApiV1MemberMutationError = ErrorType<unknown>

    export const usePutApiV1Member = <TData = Awaited<ReturnType<typeof putApiV1Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {data: BodyType<UpdateMemberRequest>},
        TContext
      > => {

      const mutationOptions = getPutApiV1MemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiV1MemberSessionIdUnion = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUnitResponseModel>(
      {url: `/proxy/api/v1/member/${sessionId}/union`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdUnionQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/union`] as const;
    }

    
export const getGetApiV1MemberSessionIdUnionQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdUnionQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>> = ({ signal }) => getApiV1MemberSessionIdUnion(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdUnionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>>
export type GetApiV1MemberSessionIdUnionQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdUnion<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdUnionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdUnionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdUnionQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>> = ({ signal }) => getApiV1MemberSessionIdUnion(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdUnionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>>
export type GetApiV1MemberSessionIdUnionSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdUnionSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdUnionSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberSessionIdAssignments = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Assignment[]>(
      {url: `/proxy/api/v1/member/${sessionId}/assignments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdAssignmentsQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/assignments`] as const;
    }

    
export const getGetApiV1MemberSessionIdAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdAssignmentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>> = ({ signal }) => getApiV1MemberSessionIdAssignments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>>
export type GetApiV1MemberSessionIdAssignmentsQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdAssignments<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdAssignmentsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdAssignmentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>> = ({ signal }) => getApiV1MemberSessionIdAssignments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>>
export type GetApiV1MemberSessionIdAssignmentsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdAssignmentsSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdAssignmentsSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberV2SessionIdAssignments = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Assignment[]>(
      {url: `/proxy/api/v1/member/v2/${sessionId}/assignments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberV2SessionIdAssignmentsQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/v2/${sessionId}/assignments`] as const;
    }

    
export const getGetApiV1MemberV2SessionIdAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdAssignmentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>> = ({ signal }) => getApiV1MemberV2SessionIdAssignments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>>
export type GetApiV1MemberV2SessionIdAssignmentsQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionIdAssignments<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdAssignmentsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberV2SessionIdAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdAssignmentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>> = ({ signal }) => getApiV1MemberV2SessionIdAssignments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>>
export type GetApiV1MemberV2SessionIdAssignmentsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionIdAssignmentsSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdAssignments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdAssignmentsSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberSessionIdEmployments = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Employment[]>(
      {url: `/proxy/api/v1/member/${sessionId}/employments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdEmploymentsQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/employments`] as const;
    }

    
export const getGetApiV1MemberSessionIdEmploymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>> = ({ signal }) => getApiV1MemberSessionIdEmployments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>>
export type GetApiV1MemberSessionIdEmploymentsQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmployments<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdEmploymentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>> = ({ signal }) => getApiV1MemberSessionIdEmployments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>>
export type GetApiV1MemberSessionIdEmploymentsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberSessionIdEmploymentsPrevious = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Employment[]>(
      {url: `/proxy/api/v1/member/${sessionId}/employments/previous`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdEmploymentsPreviousQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/employments/previous`] as const;
    }

    
export const getGetApiV1MemberSessionIdEmploymentsPreviousQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsPreviousQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsPrevious(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsPreviousQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>>
export type GetApiV1MemberSessionIdEmploymentsPreviousQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsPrevious<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsPreviousQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdEmploymentsPreviousSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsPreviousQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsPrevious(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsPreviousSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>>
export type GetApiV1MemberSessionIdEmploymentsPreviousSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsPreviousSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsPrevious>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsPreviousSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberSessionIdEmploymentsCurrent = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Employment[]>(
      {url: `/proxy/api/v1/member/${sessionId}/employments/current`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdEmploymentsCurrentQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/employments/current`] as const;
    }

    
export const getGetApiV1MemberSessionIdEmploymentsCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsCurrentQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsCurrent(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>>
export type GetApiV1MemberSessionIdEmploymentsCurrentQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsCurrent<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsCurrentQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdEmploymentsCurrentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsCurrentQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsCurrent(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsCurrentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>>
export type GetApiV1MemberSessionIdEmploymentsCurrentSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsCurrentSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsCurrent>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsCurrentSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberSessionIdEmploymentsNext = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Employment[]>(
      {url: `/proxy/api/v1/member/${sessionId}/employments/next`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberSessionIdEmploymentsNextQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/${sessionId}/employments/next`] as const;
    }

    
export const getGetApiV1MemberSessionIdEmploymentsNextQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsNextQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsNext(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsNextQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>>
export type GetApiV1MemberSessionIdEmploymentsNextQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsNext<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsNextQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberSessionIdEmploymentsNextSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberSessionIdEmploymentsNextQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>> = ({ signal }) => getApiV1MemberSessionIdEmploymentsNext(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberSessionIdEmploymentsNextSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>>
export type GetApiV1MemberSessionIdEmploymentsNextSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberSessionIdEmploymentsNextSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberSessionIdEmploymentsNext>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberSessionIdEmploymentsNextSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberV2SessionIdEmployments = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmploymentV2Model[]>(
      {url: `/proxy/api/v1/member/v2/${sessionId}/employments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberV2SessionIdEmploymentsQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v1/member/v2/${sessionId}/employments`] as const;
    }

    
export const getGetApiV1MemberV2SessionIdEmploymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdEmploymentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>> = ({ signal }) => getApiV1MemberV2SessionIdEmployments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdEmploymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>>
export type GetApiV1MemberV2SessionIdEmploymentsQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionIdEmployments<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdEmploymentsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberV2SessionIdEmploymentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberV2SessionIdEmploymentsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>> = ({ signal }) => getApiV1MemberV2SessionIdEmployments(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberV2SessionIdEmploymentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>>
export type GetApiV1MemberV2SessionIdEmploymentsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberV2SessionIdEmploymentsSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberV2SessionIdEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberV2SessionIdEmploymentsSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiV1MemberUpdateEmployment = (
    updateMemberEmploymentRequest: BodyType<UpdateMemberEmploymentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/proxy/api/v1/member/update-employment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberEmploymentRequest, signal
    },
      options);
    }
  


export const getPostApiV1MemberUpdateEmploymentMutationOptions = <TData = Awaited<ReturnType<typeof postApiV1MemberUpdateEmployment>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberEmploymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV1MemberUpdateEmployment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MemberUpdateEmployment>>, {data: BodyType<UpdateMemberEmploymentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MemberUpdateEmployment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberEmploymentRequest>}, TContext>}

    export type PostApiV1MemberUpdateEmploymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MemberUpdateEmployment>>>
    export type PostApiV1MemberUpdateEmploymentMutationBody = BodyType<UpdateMemberEmploymentRequest>
    export type PostApiV1MemberUpdateEmploymentMutationError = ErrorType<unknown>

    export const usePostApiV1MemberUpdateEmployment = <TData = Awaited<ReturnType<typeof postApiV1MemberUpdateEmployment>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberEmploymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {data: BodyType<UpdateMemberEmploymentRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiV1MemberUpdateEmploymentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiV1MemberUpdateNewEmployment = (
    updateMemberNewEmploymentRequest: BodyType<UpdateMemberNewEmploymentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/proxy/api/v1/member/update-new-employment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberNewEmploymentRequest, signal
    },
      options);
    }
  


export const getPostApiV1MemberUpdateNewEmploymentMutationOptions = <TData = Awaited<ReturnType<typeof postApiV1MemberUpdateNewEmployment>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberNewEmploymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV1MemberUpdateNewEmployment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MemberUpdateNewEmployment>>, {data: BodyType<UpdateMemberNewEmploymentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MemberUpdateNewEmployment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberNewEmploymentRequest>}, TContext>}

    export type PostApiV1MemberUpdateNewEmploymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MemberUpdateNewEmployment>>>
    export type PostApiV1MemberUpdateNewEmploymentMutationBody = BodyType<UpdateMemberNewEmploymentRequest>
    export type PostApiV1MemberUpdateNewEmploymentMutationError = ErrorType<unknown>

    export const usePostApiV1MemberUpdateNewEmployment = <TData = Awaited<ReturnType<typeof postApiV1MemberUpdateNewEmployment>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdateMemberNewEmploymentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {data: BodyType<UpdateMemberNewEmploymentRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiV1MemberUpdateNewEmploymentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiV1MemberBookings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberBooking[]>(
      {url: `/proxy/api/v1/member/bookings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1MemberBookingsQueryKey = () => {
    return [`/proxy/api/v1/member/bookings`] as const;
    }

    
export const getGetApiV1MemberBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberBookings>>> = ({ signal }) => getApiV1MemberBookings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberBookings>>>
export type GetApiV1MemberBookingsQueryError = ErrorType<unknown>



export function useGetApiV1MemberBookings<TData = Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberBookingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberBookingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberBookings>>> = ({ signal }) => getApiV1MemberBookings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberBookingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberBookings>>>
export type GetApiV1MemberBookingsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV1MemberBookingsSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberBookingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV1MemberClubMembers = (
    params?: GetApiV1MemberClubMembersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ClubMember[]>(
      {url: `/proxy/api/v1/member/club-members`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiV1MemberClubMembersQueryKey = (params?: GetApiV1MemberClubMembersParams,) => {
    return [`/proxy/api/v1/member/club-members`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiV1MemberClubMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError = ErrorType<ProblemDetails>>(params?: GetApiV1MemberClubMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberClubMembersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>> = ({ signal }) => getApiV1MemberClubMembers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberClubMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>>
export type GetApiV1MemberClubMembersQueryError = ErrorType<ProblemDetails>



export function useGetApiV1MemberClubMembers<TData = Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError = ErrorType<ProblemDetails>>(
 params?: GetApiV1MemberClubMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberClubMembersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1MemberClubMembersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError = ErrorType<ProblemDetails>>(params?: GetApiV1MemberClubMembersParams, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MemberClubMembersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>> = ({ signal }) => getApiV1MemberClubMembers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1MemberClubMembersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>>
export type GetApiV1MemberClubMembersSuspenseQueryError = ErrorType<ProblemDetails>



export function useGetApiV1MemberClubMembersSuspense<TData = Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError = ErrorType<ProblemDetails>>(
 params?: GetApiV1MemberClubMembersParams, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV1MemberClubMembers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV1MemberClubMembersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



